import React, { Component } from 'react'
import PropTypes from 'prop-types'
import firebase from 'firebase/app'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { IS_ADMIN } from './constant'
import { navigate, getCountData } from './actions/app'
import { onAuthChange } from './actions/profile'
import Notification from './containers/Notification'


class App extends Component {
  /* LIFECYCLE */

  /**
   * @componentWillMount
   */
  componentWillMount() {
    const { pathname, location } = this.props

    firebase.auth().onAuthStateChanged(this.props.onAuthChange)

    if (IS_ADMIN) {
      this.props.getCountData()
    }

    if (location?.pathname !== pathname) {
      this.props.navigate(location.pathname)
    }
  }

  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - next Properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const {
      history,
      location,
      pathname,
    } = nextProps

    if (pathname !== this.props.pathname && pathname !== this.props.location.pathname) {
      history.push(pathname)
    }

    if (location?.pathname !== this.props.location?.pathname && location?.pathname !== pathname) {
      this.props.navigate(location.pathname)
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    return (
      <div>
        {this.props.children}
        <Notification />
      </div>
    )
  }
}


App.propTypes = {
  navigate: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  getCountData: PropTypes.func.isRequired,
  onAuthChange: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  pathname: state.app.pathname,
})


export default withRouter(connect(mapStateToProps, {
  navigate,
  getCountData,
  onAuthChange,
})(App))
